import type { IRootState } from '../types';

export * from './feed/selectors';

export const selectSearchMetadata = (state: IRootState) => ({
  isError: state.search.error,
  isLoading: state.search.pending,
});
